// @flow
import React from 'react';
import PropTypes from 'prop-types';
import TotalProducts from './TotalProductsComponent';
import AccountManager from './AccountManagerComponent';
import dashboardMessages from '../../data/dashboard';
import CustomerInfo from './CustomerInfoComponent';
import Announcements from './AnnouncementsComponent';
import NewProductButton from '../common/new-product-button/NewProductButtonComponent';
import OrderHistory from './OrderHistoryComponent';
import UnauthorizedComponent from '../unauthorized/UnauthorizedComponent';
import { canAccessDashboard } from '../services/user-permission/UserPermissionService';

import './DashboardPage.scss';

class DashboardPageComponent extends React.Component {
  static propTypes = {
    actions: PropTypes.shape({
      getDashboardData: PropTypes.func.isRequired,
    }),
    dashboard: PropTypes.object.isRequired,
    account: PropTypes.object.isRequired,
  };

  static contextTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }),
  };

  componentDidMount() {
    this.props.actions.getDashboardData();
  }

  render() {
    const { config, actions, dashboard, account } = this.props;
    const isLoading = dashboard.isLoading || Object.keys(account.details).length === 0;

    if (!isLoading && !canAccessDashboard(config.permissions)) {
      return <UnauthorizedComponent contactDetails={config.contacts.toPopulateProductPage} />;
    }

    const { totalProducts, accountManager } = dashboard;

    return (
      <div className="dashboard-page">
        <div className="dashboard-page__content u-padding-s u-padding-l@medium">
          <h2 className="u-fontSize-xl">{this.context.intl.formatMessage(dashboardMessages.dashboardTitle)}</h2>
          {!isLoading && <NewProductButton config={config} actions={actions} tooltipAlwaysActive />}
          <div className="dashboard-page__columns">
            <div className="dashboard-page__column dashboard-page__column--small">
              <CustomerInfo isLoading={isLoading} name={dashboard.name} companyName={account.details.companyName} />
              <TotalProducts isLoading={isLoading} total={totalProducts} />
            </div>
            <div className="dashboard-page__column dashboard-page__column--large">
              <OrderHistory
                isLoading={isLoading}
                title={this.context.intl.formatMessage(dashboardMessages.orderHistoryTitle)}
                items={dashboard.orders}
              />
              <AccountManager isLoading={isLoading} info={accountManager} />
              <Announcements isLoading={isLoading} locale={config.selectedLocale} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DashboardPageComponent;
